export default "__VITE_ASSET__DvQJnU0b__"